// extracted by mini-css-extract-plugin
export var container = "_f8-0";
export var content = "_f8-3";
export var customerTitle = "_f8-4";
export var empty = "_f8-5";
export var gray = "_f8-6";
export var header = "_f8-7";
export var info = "_f8-8";
export var loading = "_f8-2";
export var loadingCard = "_f8-9";
export var oneLine = "_f8-a";
export var personName = "_f8-e";
export var pillContainer = "_f8-b";
export var selected = "_f8-1";
export var text = "_f8-c";
export var twoLines = "_f8-d";
export var unread = "_f8-f";
export var unreadIndicator = "_f8-g";